export default __webpack_public_path__ + "static/media/qrcode-detail.138707b9.png";